import React, { useEffect, useState } from "react";
import whatsNew from "../../assets/images/new.png";
import guide from "../../assets/images/guide.png";
import { Link, NavLink } from "react-router-dom";
import { ChartBarIcon, Cog8ToothIcon, GiftIcon, HomeIcon, LightBulbIcon, TrophyIcon } from '@heroicons/react/24/solid'

function Menu(props) {

  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "api/analytics/UserRole")
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          if (data.userrole == 'Admin' || data.userrole == 'LnD') {
            setAllowed(true);
          }

        }
      });
  }, [])

  return (
    <>
      <div className="menu-main menu-width">
        <div className="menu-fixed menu-width">
          <div className="hd-spacing"></div>
          <div className="menu-top">
            <nav>
              <ul className="mt-ul menu-ul">
                <li>
                  <NavLink to="/home" activeClassName="active" onClick={() => props.setMenuToggle(!props.menuToggle)}>
                    <div className="mt-link menu-link">
                      <div className="mt-img">
                        <HomeIcon className="w-4 h-4 text-white" style={{ width: '16px' }} />
                      </div>
                      <span>Home</span>
                    </div>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/rewards" activeClassName="active" onClick={() => props.setMenuToggle(!props.menuToggle)}>
                    <div className="mt-link menu-link">
                      <div className="mt-img">
                        <GiftIcon className="w-4 h-4 text-white" style={{ width: '16px' }} />
                      </div>
                      <span>Rewards</span>
                    </div>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/badges" activeClassName="active" onClick={() => props.setMenuToggle(!props.menuToggle)}>
                    <div className="mt-link menu-link">
                      <div className="mt-img">
                        <TrophyIcon className="w-4 h-4 text-white" style={{ width: '16px' }} />
                      </div>
                      <span>Badges</span>
                    </div>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/feedback" activeClassName="active" onClick={() => props.setMenuToggle(!props.menuToggle)}>
                    <div className="mt-link menu-link">
                      <div className="mt-img">
                        <LightBulbIcon className="w-4 h-4 text-white" style={{ width: '16px' }} />
                      </div>
                      <span>Feedback</span>
                    </div>
                  </NavLink>
                </li>
                {allowed &&
                  <>
                    <li>
                      <NavLink to={"/analytics"} onClick={() => props.setMenuToggle(!props.menuToggle)}>
                        <div className="mt-link menu-link">
                          <div className="mt-img">
                            <ChartBarIcon className="w-4 h-4 text-white" style={{ width: '16px' }} />
                          </div>
                          <span>Analytics</span>
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/admin"} onClick={() => props.setMenuToggle(!props.menuToggle)}>
                        <div className="mt-link menu-link">
                          <div className="mt-img">
                            <Cog8ToothIcon className="w-4 h-4 text-white focus:text-[#ecf1f9]" style={{ width: '16px' }} />
                          </div>
                          <span>Admin</span>
                        </div>
                      </NavLink>
                    </li>
                  </>}

                {/* <li>
                <a href="/">
                  <div className="mt-link menu-link">
                    <div className="mt-analytics mt-img"></div>
                    <span>Analytics</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="/">
                  <div className="mt-link menu-link">
                    <div className="mt-integration mt-img"></div>
                    <span>Integration</span>
                  </div>
                </a>
              </li> */}
              </ul>
            </nav>
          </div>
          {/* <div className="menu-bottom">
          <nav className="mb-nav">
            <ul className="mb-ul menu-ul">
              <li>
                <a href="/">
                  <div className="mb-link menu-link">
                    <div
                      className="mt-img"
                      style={{ backgroundImage: `url(${whatsNew})` }}
                    ></div>
                    <span>What's new</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="/">
                  <div className="mb-link menu-link">
                    <div
                      className="mt-img"
                      style={{ backgroundImage: `url(${guide})` }}
                    ></div>
                    <span>Setup guide</span>
                  </div>
                </a>
              </li>
            </ul>
          </nav>
        </div> */}
        </div>
      </div>
      <div className="menu-overlay" onClick={() => props.setMenuToggle(!props.menuToggle)}></div>
    </>
  );
}

export default Menu;
